export default __webpack_public_path__ + "static/media/centerBoard.17a976c1.jpeg";